(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yuno-service-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yuno-service-help')) {
    customElements.define('yuno-service-help', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.toggle = this.querySelector('[data-yuno-help-toggle]');
        this.panel = this.querySelector('[data-yuno-help-panel]');
        const options = { signal: this.controller.signal };
        this.toggle.addEventListener('click', () => this.setOpen(this.panel.hidden), options);
        this.querySelector('[data-yuno-help-close]').addEventListener('click', () => this.setOpen(false, true), options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.panel.hidden) {
            this.setOpen(false, true);
            event.stopPropagation();
          }
        }, options);
      }
      setOpen(open, returnFocus = false) {
        this.panel.hidden = !open;
        this.toggle.setAttribute('aria-expanded', String(open));
        if (returnFocus) this.toggle.focus();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yuno-service-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-yuno-service-link]');
    const drawer = link?.closest('header-drawer');
    if (!drawer) return;
    const details = drawer.querySelector('details');
    const summary = details?.querySelector('summary');
    if (typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer(event, summary);
    } else if (details) {
      details.removeAttribute('open');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
